module.exports = __webpack_public_path__ + "img/Screen_Shot_5.1b400b3e.png";